
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[website]/home",
      function () {
        return require("private-next-pages/[website]/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[website]/home"])
      });
    }
  